<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='30%' content-class="flex xs12 sm6 md6")
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-divider
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-text-field(dense, outlined, v-model='form.codFabricante', type='number' id='codFabricante', label='Código')
                  v-col(cols='12' sm='12' md='12')
                    v-text-field(dense, outlined, v-model='form.nombre', id='nombreFabricante', label='Nombre', v-uppercase)
                  v-col(cols='12' sm='12' md='12' v-if='editedIndex === -1')
                    v-autocomplete(autocomplete="off" dense outlined :menu-props="{closeOnContentClick: true}" multiple='multiple' :readonly='read' v-model='form.marca' :items='idMarcaArray' id='marcasF' label='Seleccione las marcas')
                  v-col(cols='12' sm='12' md='12' v-else)
                    v-autocomplete(autocomplete="off" dense outlined :menu-props="{closeOnContentClick: true}" multiple='multiple' :readonly='read' v-model='marcaSelec' :items='idMarcaArray' id='marcasF' label='Seleccione las marcas')
                      template(v-slot:prepend-item v-if="validarCrearMar()")
                        v-list(dense)
                          v-list-item( @click='marcaM = true')
                            v-list-item-avatar(color='grey lighten-3')
                              v-btn.mx-2(fab dark x-small color='teal darken-4')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Marca
                    MarcaM(:dialog='marcaM' :editedIndex='-1' @close='marcaM = false' @save='listarMarcas')
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(color='teal darken-4' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>
<script>
import Api from '@/services/methods'
import MarcaM from './MarcaM'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    marcaM: false,
    marcaSelec: [],
    marca: [],
    idMarcaArray: [],
    permisosMar: {},
    form: {
      codFabricante: '',
      nombre: '',
      marca: []
    },
    defaultItem: {
      codFabricante: '',
      nombre: '',
      marca: []
    }
  }),
  components: {
    MarcaM
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Fabricante'
        : this.read
          ? 'Informacion del Fabricante'
          : 'Modificar Fabricante'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
      this.marcaSelec = []
      this.form.marca.map(data => {
        this.marcaSelec.push(data._id)
      })
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarMarcas();
      this.permisosMar = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == "Marca");
    },

    validarCrearMar () {
      return true
      return this.permisosMar?.accion.includes('Crear')
    },

    listarMarcas () {
      Api.get('marca')
        .then(response => {
          this.marca = response.data
          this.marca.map(data => {
            this.idMarcaArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.nombre = ''
        this.marca = []
      }, 300)
      // pone el dialog del padre en false
      this.$emit('close')
    },

    validarCampos () {
      if (this.form.nombre === '' || this.form.codFabricante === '' ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene los campos para continuar'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          this.form.marca = this.marcaSelec
          Api.put('fabricante', this.form)
            .then(response => {
              this.$emit('edited')
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modiicar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        } else {
          Api.post('fabricante', this.form)
            .then(response => {
              this.$emit('save')
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        }
      }
    }
  }
}
</script>
